import React from 'react';
import { howItWorksSteps } from '../data/mock';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-container">
      <div className="section-header">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">Three simple steps to confident investing</p>
      </div>

      <div className="steps-grid">
        {howItWorksSteps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-number">{step.number}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
            {step.example && (
              <div className="step-example">
                {step.example}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
